<script setup lang="ts">
import PhList from '~icons/ph/list'

const props = defineProps<{
  title?: string
}>()

const appStore = useAppStore()
const { openNav } = useAppNav()

const heading = computed(() => props.title || appStore.spotInfo?.name)
</script>

<template>
  <div
    class="flex shrink-0 items-center gap-3 bg-slate-800 px-4 py-2 md:py-4"
  >
    <button
      type="button"
      aria-label="Open navigation"
      class="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-white md:h-[50px] md:w-[50px]"
      @click="openNav()"
    >
      <PhList class="h-[19px] w-[19px] md:h-6 md:w-6" />
      <span
        v-if="appStore.menusEnabled"
        class="absolute -right-0.5 -top-0.5 h-[13px] w-[13px] rounded-full border-2 border-slate-800 bg-lime-500"
      />
    </button>

    <span
      class="min-w-0 flex-1 truncate text-base font-semibold text-white md:text-lg"
    >
      {{ heading }}
    </span>

    <slot />
  </div>
</template>
